import { Injectable, signal, WritableSignal } from "@angular/core";
import { Title } from "@angular/platform-browser";

/**
 * PURPOSE: responsible for state management throughout the application
 */
@Injectable({
  providedIn: "root"
})
export class StateManagementService {
  private _pageHeading: WritableSignal<string | undefined> = signal(undefined);

  constructor(private titleService: Title) {}

  get pageHeading(): WritableSignal<string | undefined> {
    return this._pageHeading;
  }

  public setPageTitle(pageTitle: string): void {
    this.titleService.setTitle(pageTitle);
  }

  public resetHeadingAndTitle(): void {
    this.titleService.setTitle("Agentium");
    this.pageHeading.set("Claim-it Marketplace");
  }
}
